module.exports = __webpack_public_path__ + "static/img/zhi.359518f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhi.png
// module id = Nh0L
// module chunks = 1